import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { for: "" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { for: "" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { for: "" }
const _hoisted_11 = { class: "dropdown-wrap unit-dropdown position-relative" }
const _hoisted_12 = { class: "mr-3" }
const _hoisted_13 = { class: "dropdown-actions" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "" }
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = { class: "control-wrap" }
const _hoisted_21 = { class: "col-md-2" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { for: "" }
const _hoisted_24 = { class: "d-flex" }
const _hoisted_25 = { class: "control-wrap" }
const _hoisted_26 = {
  key: 0,
  class: "dropdown-wrap position-relative"
}
const _hoisted_27 = {
  class: "btn-sm bg-light h-100 rounded-0",
  type: "button",
  "aria-expanded": "false"
}
const _hoisted_28 = { class: "mr-3" }
const _hoisted_29 = {
  key: 1,
  class: "dropdown-wrap position-relative"
}
const _hoisted_30 = {
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_31 = { class: "mr-3" }
const _hoisted_32 = { class: "col-md-2" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { for: "" }
const _hoisted_35 = { class: "d-flex" }
const _hoisted_36 = { class: "control-wrap" }
const _hoisted_37 = {
  key: 0,
  class: "form-group"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_40 = {
  key: 1,
  class: "table-responsive my-3 font-12 with-line-item"
}
const _hoisted_41 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_42 = { class: "table-primary nowrap-text" }
const _hoisted_43 = { class: "table-input-checked-wrap" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  class: "dropdown-wrap unit-dropdown position-relative"
}
const _hoisted_46 = { class: "mr-3" }
const _hoisted_47 = { class: "dropdown-actions" }
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_50 = { class: "d-flex" }
const _hoisted_51 = {
  class: "control-wrap",
  style: { width: '100%' }
}
const _hoisted_52 = { class: "d-flex" }
const _hoisted_53 = { class: "control-wrap" }
const _hoisted_54 = {
  key: 0,
  class: "dropdown-wrap position-relative"
}
const _hoisted_55 = {
  class: "btn-sm bg-light h-100 rounded-0",
  type: "button",
  "aria-expanded": "false"
}
const _hoisted_56 = { class: "mr-3" }
const _hoisted_57 = {
  key: 1,
  class: "dropdown-wrap position-relative"
}
const _hoisted_58 = {
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_59 = { class: "mr-3" }
const _hoisted_60 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_64 = {
  key: 2,
  class: "form-group"
}
const _hoisted_65 = {
  key: 3,
  class: "form-group"
}
const _hoisted_66 = { class: "modal-wrap default-modal" }
const _hoisted_67 = {
  class: "modal fade",
  id: "addUnite1",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_68 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_69 = { class: "modal-content" }
const _hoisted_70 = { class: "modal-header" }
const _hoisted_71 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_72 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_74 = { class: "modal-body" }
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = { for: "" }
const _hoisted_77 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_78 = { class: "form-group" }
const _hoisted_79 = { for: "" }
const _hoisted_80 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_81 = { class: "modal-footer" }
const _hoisted_82 = { class: "modal-wrap default-modal" }
const _hoisted_83 = {
  class: "modal fade",
  id: "removeSubItem",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_84 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_85 = { class: "modal-content" }
const _hoisted_86 = { class: "modal-header" }
const _hoisted_87 = {
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_89 = { class: "modal-body" }
const _hoisted_90 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_91 = { class: "modal-footer" }
const _hoisted_92 = { class: "modal-wrap default-modal" }
const _hoisted_93 = {
  class: "modal fade",
  id: "deleteItem",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_94 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_95 = { class: "modal-content" }
const _hoisted_96 = { class: "modal-header" }
const _hoisted_97 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_98 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_99 = { class: "modal-body" }
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_101 = { class: "text-danger" }
const _hoisted_102 = { class: "modal-footer" }
const _hoisted_103 = { class: "modal-wrap default-modal" }
const _hoisted_104 = {
  class: "modal fade",
  id: "deleteSubItem",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_105 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_106 = { class: "modal-content" }
const _hoisted_107 = { class: "modal-header" }
const _hoisted_108 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_109 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_110 = { class: "modal-body" }
const _hoisted_111 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_112 = { class: "text-danger" }
const _hoisted_113 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_PriceInputField = _resolveComponent("PriceInputField")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.errors.errorList.createLineItem,
        hasError: _ctx.state.ui.errors.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('main_title')), 1),
        _withDirectives(_createVNode("input", {
          type: "text",
          class: _ctx.state.ui.errors.validationErrorList.itemName ? 'form-control error-field' : 'form-control',
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.itemName = $event)),
          disabled: _ctx.state.ui.isLoading.isShow
        }, null, 10, ["disabled"]), [
          [_vModelText, _ctx.state.data.itemName]
        ]),
        (_ctx.state.ui.errors.validationErrorList.itemName)
          ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.state.ui.errors.validationErrorList.itemName), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('description')), 1),
        _withDirectives(_createVNode("textarea", {
          class: "form-control",
          rows: 5,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.itemDetails = $event)),
          disabled: _ctx.state.ui.isLoading.isShow
        }, null, 8, ["disabled"]), [
          [_vModelText, _ctx.state.data.itemDetails]
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('unit')), 1),
            _createVNode("div", _hoisted_11, [
              _createVNode("a", {
                class: _ctx.state.ui.errors.validationErrorList.itemUnitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                type: "button",
                "data-toggle": "dropdown",
                "aria-expanded": "false",
                disabled: _ctx.state.ui.isLoading.isShow
              }, [
                _createVNode("span", _hoisted_12, _toDisplayString(_ctx.state.data.selectedUnit.name ?
                    _ctx.state.data.selectedUnit.name : _ctx.$t('select_unit')), 1)
              ], 10, ["disabled"]),
              _createVNode("div", {
                class: "dropdown-menu custom-scroll table-dropdown",
                disabled: _ctx.state.ui.isLoading.isShow
              }, [
                _createVNode("a", {
                  class: "dropdown-item border-bottom text-success",
                  href: "javascript:void(0)",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNewUnit(null)))
                }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                  return (_openBlock(), _createBlock("a", {
                    class: "dropdown-item with-actions",
                    href: "javascript:void(0)",
                    key: unitIndex
                  }, [
                    _createVNode("span", {
                      class: "unit-title d-block",
                      onClick: ($event: any) => (_ctx.selectUnit(unit))
                    }, _toDisplayString(unit.name), 9, ["onClick"]),
                    _createVNode("span", _hoisted_13, [
                      _createVNode("span", {
                        class: "actions-text",
                        onClick: ($event: any) => (_ctx.editUnit(unit))
                      }, [
                        _hoisted_14
                      ], 8, ["onClick"]),
                      _createVNode("span", {
                        class: "actions-text ml-2",
                        onClick: ($event: any) => (_ctx.deleteUnit(null, unit))
                      }, [
                        _hoisted_15
                      ], 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ], 8, ["disabled"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('cost')), 1),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_PriceInputField, {
                  parentClass: _ctx.state.ui.errors.validationErrorList.itemCostError ? 'form-control error-field' : 'form-control',
                  price: _ctx.state.data.itemCost,
                  onUpdateItem: _ctx.setCost,
                  onKeyup: _ctx.calculateiItemTotal
                }, null, 8, ["parentClass", "price", "onUpdateItem", "onKeyup"])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('markup')), 1),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                (_ctx.state.data.itemMarkupType == 0)
                  ? (_openBlock(), _createBlock(_component_PriceInputField, {
                      key: 0,
                      parentClass: 'form-control',
                      price: _ctx.state.data.itemMarkup,
                      onUpdateItem: _ctx.setMarkup,
                      onKeyup: _ctx.calculateiItemTotal
                    }, null, 8, ["price", "onUpdateItem", "onKeyup"]))
                  : _createCommentVNode("", true),
                (_ctx.state.data.itemMarkupType == 1)
                  ? (_openBlock(), _createBlock(_component_PriceInputField, {
                      key: 1,
                      parentClass: 'form-control',
                      price: _ctx.state.data.itemMarkup,
                      from: _ctx.state.data.inputFrom,
                      onUpdateItem: _ctx.setMarkup,
                      onKeyup: _ctx.calculateiItemTotal
                    }, null, 8, ["price", "from", "onUpdateItem", "onKeyup"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.state.ui.isLoading.isShow)
                ? (_openBlock(), _createBlock("div", _hoisted_26, [
                    _createVNode("a", _hoisted_27, [
                      _createVNode("span", _hoisted_28, _toDisplayString(_ctx.state.data.itemMarkupType == 0 ? '$' : '%'), 1)
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_29, [
                    _createVNode("a", _hoisted_30, [
                      _createVNode("span", _hoisted_31, _toDisplayString(_ctx.state.data.itemMarkupType == 0 ? '$' : '%'), 1)
                    ]),
                    _createVNode("div", {
                      class: "dropdown-menu with-badge-list",
                      disabled: _ctx.state.ui.isLoading.isShow
                    }, [
                      _createVNode("ul", null, [
                        _createVNode("li", null, [
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeItemMarkupType(0)))
                          }, "$ "),
                          (_ctx.state.defMarkUpType != 0)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                class: "badge badge-success",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateMarkupType(0)))
                              }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("li", null, [
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeItemMarkupType(1)))
                          }, "%"),
                          (_ctx.state.defMarkUpType != 1)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                class: "badge badge-success",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateMarkupType(1)))
                              }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 8, ["disabled"])
                  ]))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, [
            _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('total')), 1),
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, _toDisplayString(_ctx.state.data.itemTotal), 1)
            ])
          ])
        ])
      ]),
      ((!_ctx.state.ui.isLoading.isShow && !_ctx.state.ui.isLoading.isEdit) || (_ctx.state.ui.isLoading.isEdit && _ctx.state.data.subItems.length == 0))
        ? (_openBlock(), _createBlock("div", _hoisted_37, [
            (_ctx.state.ui.isLoading.enableSubItem && _ctx.state.data.subItems.length > 0)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn delete-btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showRemoveSubItem()))
                }, [
                  _hoisted_38,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('delete_all_subitem')), 1)
                ]))
              : (_openBlock(), _createBlock("button", {
                  key: 1,
                  class: "btn default-btn d-inline-block",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addSubItem()))
                }, [
                  _hoisted_39,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add_subitem')), 1)
                ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.ui.isLoading.enableSubItem && _ctx.state.data.subItems.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_40, [
            _createVNode("table", _hoisted_41, [
              _createVNode("thead", _hoisted_42, [
                _createVNode("tr", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
                    return (_openBlock(), _createBlock("th", {
                      key: index,
                      style: { width: _ctx.columnWidths[index] + 'px' },
                      class: "resizable-column"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t(column.label)) + " ", 1),
                      _createVNode("div", {
                        class: "resizer",
                        onMousedown: ($event: any) => (_ctx.startResize(index, $event)),
                        onTouchstart: ($event: any) => (_ctx.startResize(index, $event))
                      }, null, 40, ["onMousedown", "onTouchstart"])
                    ], 4))
                  }), 128))
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.subItems, (item, itemIndex) => {
                  return (_openBlock(), _createBlock("tr", {
                    class: "",
                    key: itemIndex
                  }, [
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_43, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          id: "sub_input_file",
                          class: item.nameError ? 'form-control error-field' : 'form-control',
                          fdprocessedid: "rfchs",
                          "onUpdate:modelValue": ($event: any) => (item.name = $event),
                          disabled: _ctx.state.ui.isLoading.isShow
                        }, null, 10, ["onUpdate:modelValue", "disabled"]), [
                          [_vModelText, item.name]
                        ])
                      ])
                    ]),
                    _createVNode("td", {
                      title: item.description
                    }, [
                      _withDirectives(_createVNode("textarea", {
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (item.description = $event),
                        disabled: _ctx.state.ui.isLoading.isShow,
                        rows: 2,
                        cols: 20
                      }, null, 8, ["onUpdate:modelValue", "disabled"]), [
                        [_vModelText, item.description]
                      ])
                    ], 8, ["title"]),
                    _createVNode("td", null, [
                      (_ctx.state.ui.isLoading.isShow)
                        ? (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(item.selectUnit.name), 1))
                        : (_openBlock(), _createBlock("div", _hoisted_45, [
                            _createVNode("a", {
                              class: item.unitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-expanded": "false",
                              disabled: _ctx.state.ui.isLoading.isShow
                            }, [
                              _createVNode("span", _hoisted_46, _toDisplayString(item.selectUnit ?
                      item.selectUnit.name : 'Select Unit'), 1)
                            ], 10, ["disabled"]),
                            _createVNode("div", {
                              class: "dropdown-menu custom-scroll table-dropdown",
                              disabled: _ctx.state.ui.isLoading.isShow
                            }, [
                              _createVNode("a", {
                                class: "dropdown-item border-bottom text-success",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.addNewUnit(item))
                              }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 9, ["onClick"]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                                return (_openBlock(), _createBlock("a", {
                                  class: "dropdown-item with-actions",
                                  href: "javascript:void(0)",
                                  key: unitIndex
                                }, [
                                  _createVNode("span", {
                                    class: "unit-title d-block",
                                    onClick: ($event: any) => (_ctx.changeUnit(itemIndex, unit))
                                  }, _toDisplayString(unit.name), 9, ["onClick"]),
                                  _createVNode("span", _hoisted_47, [
                                    _createVNode("span", {
                                      class: "actions-text",
                                      onClick: ($event: any) => (_ctx.editUnit(unit))
                                    }, [
                                      _hoisted_48
                                    ], 8, ["onClick"]),
                                    _createVNode("span", {
                                      class: "actions-text ml-2",
                                      onClick: ($event: any) => (_ctx.deleteUnit(item, unit))
                                    }, [
                                      _hoisted_49
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ], 8, ["disabled"])
                          ]))
                    ]),
                    _createVNode("td", {
                      title: item.cost,
                      style: { width: _ctx.computedCostColumnWidth }
                    }, [
                      _createVNode("div", _hoisted_50, [
                        _createVNode("div", _hoisted_51, [
                          _createVNode(_component_PriceInputField, {
                            parentClass: item.costError ? 'form-control error-field' : 'form-control',
                            price: item.cost,
                            onUpdateItem: ($event: any) => (_ctx.updateItem(itemIndex, $event)),
                            onKeyup: ($event: any) => (_ctx.calculateTotal(item)),
                            style: { width: _ctx.computedCostColumnWidth }
                          }, null, 8, ["parentClass", "price", "onUpdateItem", "onKeyup", "style"])
                        ])
                      ])
                    ], 12, ["title"]),
                    _createVNode("td", {
                      title: item.markup
                    }, [
                      _createVNode("div", _hoisted_52, [
                        _createVNode("div", _hoisted_53, [
                          (item.markup_type == 0)
                            ? (_openBlock(), _createBlock(_component_PriceInputField, {
                                key: 0,
                                parentClass: 'form-control',
                                price: item.markup,
                                onUpdateItem: ($event: any) => (_ctx.updateItemMarkup(itemIndex, $event)),
                                onKeyup: ($event: any) => (_ctx.calculateTotal(item))
                              }, null, 8, ["price", "onUpdateItem", "onKeyup"]))
                            : _createCommentVNode("", true),
                          (item.markup_type == 1)
                            ? (_openBlock(), _createBlock(_component_PriceInputField, {
                                key: 1,
                                parentClass: 'form-control',
                                price: item.markup,
                                from: _ctx.state.data.inputFrom,
                                onUpdateItem: ($event: any) => (_ctx.updateItemMarkup(itemIndex, $event)),
                                onKeyup: ($event: any) => (_ctx.calculateTotal(item))
                              }, null, 8, ["price", "from", "onUpdateItem", "onKeyup"]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.state.ui.isLoading.isShow)
                          ? (_openBlock(), _createBlock("div", _hoisted_54, [
                              _createVNode("a", _hoisted_55, [
                                _createVNode("span", _hoisted_56, _toDisplayString(item.markup_type ==
                        0 ? '$' : '%'), 1)
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_57, [
                              _createVNode("a", _hoisted_58, [
                                _createVNode("span", _hoisted_59, _toDisplayString(item.markup_type == 0 ? '$' : '%'), 1)
                              ]),
                              _createVNode("div", {
                                class: "dropdown-menu with-badge-list",
                                disabled: _ctx.state.ui.isLoading.isShow
                              }, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _createVNode("a", {
                                      class: "dropdown-item",
                                      href: "javascript:void(0)",
                                      onClick: ($event: any) => (_ctx.changeMarkupType(itemIndex, 0))
                                    }, "$ ", 8, ["onClick"]),
                                    (_ctx.state.defMarkUpType != 0)
                                      ? (_openBlock(), _createBlock("span", {
                                          key: 0,
                                          class: "badge badge-success",
                                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateMarkupType(0)))
                                        }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createVNode("li", null, [
                                    _createVNode("a", {
                                      class: "dropdown-item",
                                      href: "javascript:void(0)",
                                      onClick: ($event: any) => (_ctx.changeMarkupType(itemIndex, 1))
                                    }, "%", 8, ["onClick"]),
                                    (_ctx.state.defMarkUpType != 1)
                                      ? (_openBlock(), _createBlock("span", {
                                          key: 0,
                                          class: "badge badge-success",
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateMarkupType(1)))
                                        }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ], 8, ["disabled"])
                            ]))
                      ])
                    ], 8, ["title"]),
                    _createVNode("td", null, _toDisplayString(item.total), 1),
                    (!_ctx.state.ui.isLoading.isShow)
                      ? (_openBlock(), _createBlock("td", _hoisted_60, [
                          (itemIndex == _ctx.state.data.subItems.length - 1)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: "javascript:void(0)",
                                class: "btn enable-btn mr-1",
                                onClick: ($event: any) => (_ctx.addMoreSubItems(item)),
                                disabled: _ctx.state.ui.isLoading.isShow
                              }, [
                                _hoisted_61,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                              ], 8, ["onClick", "disabled"]))
                            : _createCommentVNode("", true),
                          (_ctx.state.data.subItems.length != 1 && !_ctx.state.ui.isLoading.isEdit)
                            ? (_openBlock(), _createBlock("a", {
                                key: 1,
                                href: "javascript:void(0)",
                                class: "btn delete-btn",
                                onClick: ($event: any) => (_ctx.deleteSubItemShow(item)),
                                disabled: _ctx.state.ui.isLoading.isShow
                              }, [
                                _hoisted_62,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                              ], 8, ["onClick", "disabled"]))
                            : (_ctx.state.ui.isLoading.isEdit && _ctx.state.data.subItems.length > 0)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 2,
                                  href: "javascript:void(0)",
                                  class: "btn delete-btn",
                                  onClick: ($event: any) => (_ctx.deleteSubItemShow(item)),
                                  disabled: _ctx.state.ui.isLoading.isShow
                                }, [
                                  _hoisted_63,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                ], 8, ["onClick", "disabled"]))
                              : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.ui.isLoading.isEdit)
        ? (_openBlock(), _createBlock("div", _hoisted_64, [
            (!_ctx.state.ui.isLoading.isShow)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn default-btn d-inline-block",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateLineItem()))
                }, _toDisplayString(_ctx.$t('update')), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_65, [
            (!_ctx.state.ui.isLoading.isShow)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn default-btn d-inline-block",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.createLineItem())),
                  disabled: _ctx.state.ui.isLoading.isShow
                }, _toDisplayString(_ctx.$t('save')), 9, ["disabled"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_66, [
      _createVNode("div", _hoisted_67, [
        _createVNode("div", _hoisted_68, [
          _createVNode("div", _hoisted_69, [
            _createVNode("div", _hoisted_70, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_71, _toDisplayString(_ctx.$t('update_unit')), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_72, _toDisplayString(_ctx.$t('add_unit')), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_73
              ])
            ]),
            _createVNode("div", _hoisted_74, [
              _createVNode("div", _hoisted_75, [
                _createVNode("label", _hoisted_76, _toDisplayString(_ctx.$t('name')), 1),
                _withDirectives(_createVNode("input", {
                  class: _ctx.state.ui.errors.validationErrorList.unitName ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.data.unit.name = $event))
                }, null, 2), [
                  [_vModelText, _ctx.state.data.unit.name]
                ]),
                (_ctx.state.ui.errors.validationErrorList.unitName)
                  ? (_openBlock(), _createBlock("p", _hoisted_77, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_78, [
                _createVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('abbreviation')), 1),
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.data.unit.abbreviation = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.unit.abbreviation]
                ]),
                (_ctx.state.ui.errors.validationErrorList.unitAbbreviation)
                  ? (_openBlock(), _createBlock("p", _hoisted_80, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitAbbreviation), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_81, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.updateUnit && _ctx.updateUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('update')), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.createUnit && _ctx.createUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('save')), 1)),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_82, [
      _createVNode("div", _hoisted_83, [
        _createVNode("div", _hoisted_84, [
          _createVNode("div", _hoisted_85, [
            _createVNode("div", _hoisted_86, [
              _createVNode("h5", _hoisted_87, _toDisplayString(_ctx.$t('delete_all_subitems')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.closeRemoveSubItem && _ctx.closeRemoveSubItem(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_88
              ])
            ]),
            _createVNode("div", _hoisted_89, [
              _createVNode("div", _hoisted_90, _toDisplayString(_ctx.$t('are_you_sure_you_want_to_delete')), 1)
            ]),
            _createVNode("div", _hoisted_91, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.removeAllSubItem && _ctx.removeAllSubItem(...args)))
              }, _toDisplayString(_ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.closeRemoveSubItem && _ctx.closeRemoveSubItem(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_92, [
      _createVNode("div", _hoisted_93, [
        _createVNode("div", _hoisted_94, [
          _createVNode("div", _hoisted_95, [
            _createVNode("div", _hoisted_96, [
              _createVNode("h5", _hoisted_97, _toDisplayString(_ctx.$t('delete_item')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.deleteItemClose()))
              }, [
                _hoisted_98
              ])
            ]),
            _createVNode("div", _hoisted_99, [
              _hoisted_100,
              _createVNode("span", _hoisted_101, _toDisplayString(_ctx.$t('are_you_sure')), 1)
            ]),
            _createVNode("div", _hoisted_102, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.deleteItemClose()))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-dismiss": "modal",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.deleteItemApi()))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_103, [
      _createVNode("div", _hoisted_104, [
        _createVNode("div", _hoisted_105, [
          _createVNode("div", _hoisted_106, [
            _createVNode("div", _hoisted_107, [
              _createVNode("h5", _hoisted_108, _toDisplayString(_ctx.$t('delete_subitem')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.deleteSubItemClose()))
              }, [
                _hoisted_109
              ])
            ]),
            _createVNode("div", _hoisted_110, [
              _hoisted_111,
              _createVNode("span", _hoisted_112, _toDisplayString(_ctx.$t('are_you_sure')), 1)
            ]),
            _createVNode("div", _hoisted_113, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.deleteSubItemClose()))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-dismiss": "modal",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.deleteSubItemApi()))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}